function isImage(fileType: string) {
    return fileType === "jpg" || fileType === "png" || fileType === "png";
}
export default isImage;